"use client";
import React, { useState } from "react";
import { notifications } from "@mantine/notifications";

import { supabaseClient } from "~/globals/client";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  formValidationSchemaForgotPassword,
  type ISchemaForgotPassword,
} from "~/globals/auth";
import Button from "~/components/Button/Button";
import ValidatedBasicTextInput from "~/components/TextInput/ValidatedBasicTextInput";

export default function ForgotPasswordForm() {
  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm<ISchemaForgotPassword>({
    resolver: zodResolver(formValidationSchemaForgotPassword),
    mode: "onChange",
    shouldUseNativeValidation: false,
  });

  const { handleSubmit, formState, register } = methods;
  const { errors } = formState;

  async function handleResetPassword(data: ISchemaForgotPassword) {
    setIsLoading(true);
    try {
      const { error, data: response } =
        await supabaseClient.auth.resetPasswordForEmail(data.email, {
          redirectTo: `${location.origin}/auth/callback?next=${location.origin}/auth/update-password`,
        });
      console.log(response);
      if (error) throw error;
      notifications.show({
        title: "Reset link sent",
        message: "Please check your email. We have sent you a reset link.",
        color: "green",
      });
    } catch (err) {
      const error = err as Error;
      notifications.show({
        title: "",
        message: error.message,
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <form className="space-y-6" onSubmit={handleSubmit(handleResetPassword)}>
      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          Enter your email address
        </label>
        <ValidatedBasicTextInput
          {...register("email")}
          type="email"
          autoComplete="email"
          id="email"
          className="w-full"
          errorMessage={errors.email?.message}
        />
      </div>

      <div>
        <Button
          variant="primary"
          type="submit"
          className="w-full"
          isLoading={isLoading}
        >
          Send reset password link
        </Button>
      </div>
    </form>
  );
}
